import axios from 'axios';

export default {
  namespaced: true,

  state: {

  },

  mutations: {

  },

  actions: {
    createJournal(_, payload) {
      return axios.post(process.env.VUE_APP_API_URL + 'journals', payload);
    },

    uploadPages(_, payload) {
      return axios.post(
        process.env.VUE_APP_API_URL + 'pages', 
        payload, 
        { 'Content-Type': 'multipart/form-data' }
      );
    }
  }
};